import BrandMark from "./ui/brandMark";
import DotGrid from "./ui/dotGrid";
import PillButton from "./ui/pillButton";
import Reveal from "./ui/reveal";
import {
  FacebookIcon,
  InstagramIcon,
  TiktokIcon,
  YoutubeIcon,
} from "./ui/socialIcons";

const socials = [
  { label: "Facebook", Icon: FacebookIcon },
  { label: "Instagram", Icon: InstagramIcon },
  { label: "TikTok", Icon: TiktokIcon },
  { label: "YouTube", Icon: YoutubeIcon },
];

const columns = [
  {
    title: "Productos",
    links: ["Automatizaciones", "Integraciones", "Base de datos"],
  },
  { title: "Soluciones", links: ["App externas", "Hosting", "IA externa"] },
  { title: "Recursos", links: ["Reportes", "Blog", "Documentación"] },
  { title: "Desarrolladores", links: ["Nosotros", "Trabajos", "Socios"] },
];

const legal = ["Términos de uso", "Política de privacidad", "Seguridad"];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-nodric-ink pt-20 pb-10">
      <DotGrid color="rgba(255,255,255,0.05)" size={30} />
      <div
        aria-hidden
        className="absolute -right-40 -bottom-40 h-130 w-130 rounded-full bg-linear-to-br from-nodric-blue via-[#5b8dfb] to-[#d9c7f0] opacity-20 blur-[120px]"
      />

      <div className="relative z-10 mx-auto max-w-375 px-6 md:px-12">
        {/* CTA row */}
        <div className="flex flex-col gap-8 border-b border-dashed border-white/15 pb-14 lg:flex-row lg:items-end lg:justify-between">
          <Reveal className="max-w-[16ch]">
            <h2 className="font-display text-3xl leading-tight font-medium tracking-[0.04em] text-white md:text-5xl">
              Hablemos de tu próxima automatización
            </h2>
          </Reveal>

          <Reveal
            delay={0.1}
            className="flex flex-col items-start gap-4 lg:items-end"
          >
            <a
              href="tel:+593969099140"
              className="font-display text-2xl font-bold tracking-tight text-nodric-blue transition-opacity hover:opacity-80 md:text-3xl"
            >
              +593 96 909 9140
            </a>
            <PillButton tone="blue">Chatear</PillButton>
          </Reveal>
        </div>

        {/* nav columns + address/socials */}
        <div className="grid gap-12 py-14 lg:grid-cols-[1fr_auto]">
          <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
            {columns.map((column) => (
              <div key={column.title}>
                <h3 className="font-display text-[11px] tracking-[0.2em] text-nodric-blue uppercase">
                  {column.title}
                </h3>
                <ul className="font-body mt-5 space-y-3 text-[13px] text-white/70">
                  {column.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#"
                        className="transition-colors hover:text-white"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="flex flex-col gap-8 lg:items-end lg:border-l lg:border-dashed lg:border-white/15 lg:pl-10">
            <address className="font-display leading-relaxed font-medium text-white not-italic lg:text-right">
              Sebastián Hormaechea
              <br />
              Bolívar y Borrero 7-67
              <br />
              Cuenca - Ecuador
            </address>

            <div className="flex items-center gap-6">
              {socials.map(({ label, Icon }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  className="text-white/50 transition-all duration-300 hover:-translate-y-1 hover:text-nodric-blue"
                >
                  <Icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* bottom bar */}
        <div className="flex flex-col-reverse items-center gap-6 border-t border-dashed border-white/15 pt-8 md:flex-row md:justify-between">
          <p className="font-display text-[12px] tracking-[0.08em] text-white/50">
            © Nodric 2026. Todos los derechos reservados.
          </p>
          <ul className="font-body flex flex-wrap items-center gap-x-6 gap-y-2 text-[12px] text-white/50">
            {legal.map((link) => (
              <li key={link}>
                <a href="#" className="transition-colors hover:text-white">
                  {link}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <Reveal direction="up" className="relative z-10 mt-4 overflow-hidden px-6 md:px-12">
        <BrandMark
          variant="logotipo"
          position="left bottom"
          className="h-24 w-full max-w-180 bg-nodric-blue md:h-40"
        />
      </Reveal>
    </footer>
  );
}
